<template>
  <div v-if="is_app_loading" class="the-loading-page">
    <div :class="['the-loading-icon '+is_app_loading]"></div>
  </div>
</template>

<script>

export default {
  name: 'uniloading',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {
    is_app_loading(){
      return this.$store.state.app.is_app_loading
    },
  },
  watch: {},
  methods: {
    
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .the-loading-icon{
    $width: 150px;
    z-index: 9;

    width: $width;
    height: $width;
    background: url('/static/img/loading_svg.svg') center center no-repeat;
    background-size: 100%;
    background-color: rgba(180,180,180,0.5);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 45%;
    margin-left: -0.5 * $width;
    margin-top: -0.5 * $width;

    &.bg-breed{
      background-image: url('/static/img_anim/love_run_bg_01.gif');
    }
    &.bg-draw{
      background-image: url('/static/img_anim/draw_run_bg_02.gif');
    }
  }
</style>